import WiretapApp from 'bam-wiretap/WiretapApp';
import trackingJson from './configs/mini-score-tracking.json';

/**
 * Set the variables inside the tracking event object.
 * Should be overridden by the custom section implementations.
 * @param  {object} trackObj Config properties.
 * @param  {jquery} $el      The jquery event element.
 */

const setCustomTrackingVars = function (trackObj, $el) {
    const pageMeta = window.pageMeta;
    const { siteName, page_section, page_name } = pageMeta;

    // Replace any variables within each prop value.
    $.each(trackObj, (prop, val) => {
        let value = val.toString();

        if (value.indexOf('@') !== -1) {
            if (value.match(/@SITENAME@/)) {
                value = value.replace(/@SITENAME@/, siteName);
            }
            if (value.match(/@PAGESECTION@/)) {
                value = value.replace(/@PAGESECTION@/, page_section);
            }
            if (value.match(/@PAGENAME@/)) {
                value = value.replace(/@PAGENAME@/, page_name);
            }
            if (value.match(/@SELECTED@/)) {
                value = value.replace(
                    /@SELECTED@/,
                    $el.find('option:selected').text(),
                );
            }
            if (value.match(/@GAMESTATUS@/)) {
                value = value.replace(
                    /@GAMESTATUS@/,
                    $el.data('game-scenario'),
                );
            }
            if (value.match(/@MIGGAMEDETAILS@/)) {
                let gameDetails = '';
                const teamInfo = window.team_info;
                if (teamInfo) {
                    const awayTeam = teamInfo.find(
                        (team) => team.id === $el.data('game-away-id'),
                    ).name;
                    const homeTeam = teamInfo.find(
                        (team) => team.id === $el.data('game-home-id'),
                    ).name;
                    const gameDate = new Date(
                        $el.data('game-date').replace(/-/g, '/'),
                    );
                    const gameDateFormat = gameDate.toDateString();
                    gameDetails = `${homeTeam} vs ${awayTeam}: ${gameDateFormat}`;
                }
                value = value.replace(/@MIGGAMEDETAILS@/, gameDetails);
            }
            if (value.match(/@LINK@/)) {
                value = value.replace(/@LINK@/, $el.children('a').attr('href'));
            }
            if (value.match(/@LINKTEXT@/)) {
                value = value.replace(
                    /@LINKTEXT@/,
                    $el
                        .children('div')
                        .find('div')
                        .text(),
                );
            }
            if (value.match(/@GAMEINDEX@/)) {
                const gameIndex = $el
                    .parents('.mlb-scores__list-item--game')
                    .index();
                value = value.replace(/@GAMEINDEX@/, gameIndex);
            }

            trackObj[prop] = value;
        }

        // Remove any bad props.
        if (trackObj[prop] === 'undefined' || trackObj[prop] === null) {
            delete trackObj[prop];
        }
    });

    return trackObj;
};

export default new WiretapApp(trackingJson, setCustomTrackingVars, {});
